// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 10) return "static/js/406d750418c45882146d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f034058bc7392dfdb9b1","145":"314fd6429bda68d73922","146":"63632cfbad376f19a13a"}[chunkId] + ".chunk.js";
};